// extracted by mini-css-extract-plugin
export var preloader = "small_preloader-module--preloader--zc9sg";
export var spinner = "small_preloader-module--spinner--1RlwE";
export var wrapper = "small_preloader-module--wrapper--1EYXX";